export default __webpack_public_path__ + "static/media/connect.4ac11dfa.png";